import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import SidebarLogo from "../Image/SideBarIcon.png";
import SidebarLogo from "../../Image/SideBarIcon.png";
import { Collapse } from "antd";
import "./SideBar.css";
import { faBarsStaggered, faBell, faBible, faGreaterThan, faMoneyBill, faUser } from '@fortawesome/free-solid-svg-icons';
import uWinnLogo from "../../Image/logo192.png";
import { faCircle ,faCircleUser} from '@fortawesome/free-regular-svg-icons';

import { faCreditCard } from '@fortawesome/free-regular-svg-icons';
import { faHouse } from '@fortawesome/free-solid-svg-icons';

import { ASSETS_BASE_URL } from "../../config/constants";

import { decryptData } from "../../controllers/Encryption";
const { Panel } = Collapse;
const SidebarItem = ({ to, icon, name, isOpen, className }) => (
  <NavLink to={to} className={`link ${className}`} activeClassName="active">
    <div className="icon">{icon}</div>
    <div style={{ display: isOpen ? "block" : "none" }} className="link_text">
      {name}
    </div>
  </NavLink>
);

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const handleCollapseToggle = () => {
    setIsOpen(!isOpen);
  };
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  
  const [PERMISSIONDATA, setPermissionData] = useState('');

  const handlePermission = async () =>{
    if(user && user.admin_type !== 'Super Admin'){
      const encrypted  = JSON.parse(sessionStorage.getItem("ADMIN-PERMISSION"));
      const decrypted  = await decryptData(encrypted);
      const permission = JSON.parse(decrypted);
      setPermissionData(permission);
    }
  }

  useEffect(()=>{
    if(sessionStorage.getItem("ADMIN-PERMISSION") !== 'undefined'){
      handlePermission();
    }
  },[])
  return (
    <div
      className={`container-fluid side_bar_main_div ${
        isOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <div
        style={{ width: isOpen ? "300px" : "70px", position: "relative " }}
        className="sidebar"
      >
        <div className="top_section">
          <img
            src={SidebarLogo}
            className="sidebar_logo"
            alt="Logo"
            style={{
              display: isOpen ? "block" : "none",
              height: "50px",
              width: "auto",
            }}
          />
          <div
            style={{ marginLeft: isOpen ? "130px" : "0px" }}
            className="bars"
          >
            <FontAwesomeIcon icon={faBarsStaggered} onClick={handleCollapseToggle} />
         
          </div>
        </div>
        <div className="my_sidebar_all_section">
          <SidebarItem
            to="/dashboard"
            icon={<FontAwesomeIcon icon={faHouse} />}
            name="Dashboard"
            isOpen={isOpen}
          />
          {(user?.admin_type === 'Super Admin') && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                         <FontAwesomeIcon icon={faCircleUser} className="sidebar_collapse_iohomeoutline" />
                    
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Accounts </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  {user?.admin_type === 'Super Admin' &&(
                    <SidebarItem to="/sub-admin/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Sub Admin" isOpen={isOpen} />
                  )}
                </Panel>
              </Collapse>
            </React.Fragment>
          )}

           
        {/*{(PERMISSIONDATA?.invoice?.invoice === 'Y' || user?.admin_type === 'Super Admin') && (
            <SidebarItem to="/invoice/list" icon={<MdOutlinePayment />} name="Invoice" isOpen={isOpen} />
          )} */}
            {(PERMISSIONDATA?.customer_due?.customer_list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" />
                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Customer </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    {(PERMISSIONDATA?.customer_due?.customer_list === 'Y' || user?.admin_type === 'Super Admin') && (
                      <SidebarItem to="/customers-due/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Customer's List" isOpen={isOpen} />
                    )}
                    {(PERMISSIONDATA?.userRequest?.list === 'Y' || user?.admin_type === 'Super Admin') && (
                      <SidebarItem to="/users/request-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Request List" isOpen={isOpen} />
                    )}

                    {(PERMISSIONDATA?.userPullOutRequest?.list === 'Y' || user?.admin_type === 'Super Admin') && (
                      <SidebarItem to="/request/pull-out-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Pull-Out List" isOpen={isOpen} />
                    )}
                    <SidebarItem to="/customers/attendance"   icon={<FontAwesomeIcon icon={faCircle} />} name="User Attendance" isOpen={isOpen} />
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

            {(PERMISSIONDATA?.salesAgent?.list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Sales Agent </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                      <SidebarItem to="/sales-agent/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

            {(PERMISSIONDATA?.general_data?.update === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> General Data </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    {(PERMISSIONDATA?.general_data?.update === 'Y' || user?.admin_type === 'Super Admin') && (
                      <SidebarItem to="/general-data"   icon={<FontAwesomeIcon icon={faCircle} />} name="General Data" isOpen={isOpen} />
                    )}
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}
            
            {(PERMISSIONDATA?.invoice?.individual === 'Y' || PERMISSIONDATA?.invoice?.bulk_request === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faCreditCard} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Invoice </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    {(PERMISSIONDATA?.invoice?.individual === 'Y' || user?.admin_type === 'Super Admin') &&(
                      <SidebarItem to="/invoice/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Individual" isOpen={isOpen} />
                    )}
                    <SidebarItem to="/invoice/archive-addeditdata"   icon={<FontAwesomeIcon icon={faCircle} />} name="Archive" isOpen={isOpen} />
                    {(PERMISSIONDATA?.invoice?.bulk_request === 'Y' || user?.admin_type === 'Super Admin') &&(
                      <SidebarItem to="/invoice/request"    icon={<FontAwesomeIcon icon={faCircle} />}  name="Bulk Request" isOpen={isOpen} />
                    )}
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

            {(PERMISSIONDATA?.transaction?.list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Transaction </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    {(PERMISSIONDATA?.transaction?.list === 'Y' || user?.admin_type === 'Super Admin') &&(
                      <SidebarItem to="/transaction/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                    )}
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

            {(PERMISSIONDATA?.analyser?.list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Analyser </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    {(PERMISSIONDATA?.analyser?.list === 'Y' || user?.admin_type === 'Super Admin') &&(
                      <SidebarItem to="/analyser"   icon={<FontAwesomeIcon icon={faCircle} />} name="Analyser" isOpen={isOpen} />
                    )}
                    {(PERMISSIONDATA?.analyser?.list === 'Y' || user?.admin_type === 'Super Admin') &&(
                      <SidebarItem to="/analyser/status" icon={<FontAwesomeIcon icon={faCircle} />} name="Analyser Status" isOpen={isOpen} />
                    )}
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

            {(PERMISSIONDATA?.hourlyAnalyser?.list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Hourly Analyser </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    <SidebarItem to="/hourly-analyser"   icon={<FontAwesomeIcon icon={faCircle} />} name="Hourly Analyser" isOpen={isOpen} />
                    {(PERMISSIONDATA?.hourlyAnalyser?.winningCouponsCache === 'Y' || user?.admin_type === 'Super Admin') && (
                      <SidebarItem to="/hourly-analyser/winning-coupons-cache" icon={<FontAwesomeIcon icon={faCircle} />} name="Winning Coupons Cache" isOpen={isOpen} />
                    )}
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

            {(PERMISSIONDATA?.winnerVoucher?.list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Winner's Vouchers </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    <SidebarItem to="/winners/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

          {(PERMISSIONDATA?.notification?.list === 'Y' || user?.admin_type === 'Super Admin') && (
              <React.Fragment>
                <Collapse accordion className="my_collapse_icon">
                  <Panel
                    header={
                      <React.Fragment>
                      <FontAwesomeIcon icon={faBell} className="sidebar_collapse_iohomeoutline" />

                        <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Notifications </span>
                      </React.Fragment>
                    }
                    key="categories"
                    className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  >
                    <SidebarItem to="/notifications/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                  </Panel>
                </Collapse>
              </React.Fragment>
            )}

          
          {/* {(PERMISSIONDATA?.notifications?.notifications === 'Y' || user?.admin_type === 'Super Admin') && (
            <SidebarItem to="/notifications"    icon={<FontAwesomeIcon icon={faBellSlash} />}  name="Notifications" isOpen={isOpen} className="custom_profile_class_productList" />
          )} */}

          <React.Fragment>
            <SidebarItem
              icon={
                <FontAwesomeIcon icon={faUser} />
              }
              to='javaScript:void(0)'
              name={
                <div className="sidebar_profile_main_content_section" onClick={()=>navigate("/sub-admin/addeditdata", { state: user })} >
                  <React.Fragment>
                    <div className="sidebar_profile_main_content">
                      <div className="user_profile_pic_Admin_name">
                        <span className="user_profile_pic_Admin_panel">
                          {`${user?.admin_first_name} ${user?.admin_last_name}`}
                        </span>{" "}
                        <br />
                        <span className="user_profile_pic_Admin_panel_">
                          Admin
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                  <React.Fragment>
                  <FontAwesomeIcon icon={faGreaterThan} className="side_bar_fagreaterthan"
                      onClick={handleCollapseToggle} />
                  </React.Fragment>
                </div>
              }
              isOpen={isOpen}
              className="custom_profile_class_productList"
            >
            </SidebarItem>
          </React.Fragment>
        </div>
      </div>
      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
